import React from 'react';

import { DynamicIconWrapper, Icons, Tooltip } from '@components/common';

import styles from './RequestsActionsColumnCell.module.scss';

interface IRequestsActionsColumnCell {
	isStopUsingAsset?: boolean;
	stopUsingAsset?: () => void;
	isStopRentAssetDisable?: boolean;
	handleView: () => void;
}

const RequestsActionsColumnCell = ({
	isStopUsingAsset = false,
	stopUsingAsset,
	isStopRentAssetDisable,
	handleView,
}: IRequestsActionsColumnCell) => {
	const stopUsingAssetHandler = () => {
		if (isStopRentAssetDisable || !stopUsingAsset) return;

		stopUsingAsset();
	};

	return (
		<div className={styles.cellContainer}>
			<Tooltip content='View request card'>
				<div
					className={styles.viewIcon}
					onClick={handleView}
				>
					<DynamicIconWrapper icon={Icons.viewIcon} />
				</div>
			</Tooltip>
			{isStopUsingAsset
				&& <Tooltip content='Stop using asset'>
					<div
						className={styles.stopIcon}
						onClick={stopUsingAssetHandler}
					>
						<DynamicIconWrapper
							icon={Icons.stopIcon}
							isDisabled={isStopRentAssetDisable}
						/>
					</div>
				</Tooltip>
			}
		</div>
	);
};

export default RequestsActionsColumnCell;
